// React
import React from 'react';
import {
  Col,
  Row,
  Card,
  Form,
  Label,
  Input,
  CardBody,
  CardFooter,
} from 'reactstrap';

// Containers Injections
import {
  PageWrapper,
  InputPhone,
  InputCpfCnpj,
  ZipCodeInput,
  SelectInputWithSearchApi,
} from '../../containers/componentsInjection';

export const SuppliersFormPage = ({
  id,
  history,
  supplier,
  typeMask,
  isActive,
  validation,
  setTypeMask,
  setIsActive,
  resetCpfCnpjInput,
}) => {
  return (
    <PageWrapper title={id ? 'Editar fornecedor' : 'Adicionar fornecedor'}>
      <Card>
        <Form
          autoComplete="off"
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <CardBody>
            <Row>
              <Col md={4}>
                <div className="mb-3">
                  <Label htmlFor="name" className="form-label">
                    Pessoa
                  </Label>
                  <Input
                    id="people"
                    type="select"
                    className="form-select"
                    onChange={(e) => {
                      resetCpfCnpjInput();
                      setTypeMask(e.target.value);
                    }}
                    value={typeMask}
                  >
                    <option value="CPF">Física</option>
                    <option value="CNPJ">Jurídica</option>
                  </Input>
                </div>
              </Col>

              <Col md={4}>
                <div className="mb-3">
                  <label htmlFor="cleave-delimiters" className="form-label">
                    {typeMask === 'CPF' ? 'CPF' : 'CNPJ'}
                  </label>
                  <InputCpfCnpj
                    id="cpfInput"
                    isCPF={typeMask === 'CPF'}
                    value={validation.values.cpfInput || ''}
                    onChange={
                      typeMask === 'CPF'
                        ? (e, type) => {
                            // to limit the possibility of entering more numbers when it is CPF
                            if (type === 'CPF') {
                              validation.handleChange(e);
                            }
                          }
                        : (e) => {
                            validation.handleChange(e);
                          }
                    }
                    onBlur={validation.handleBlur}
                    invalid={
                      !!(
                        validation.touched.cpfInput &&
                        validation.errors.cpfInput
                      )
                    }
                  />
                  {validation.touched.cpfInput && validation.errors.cpfInput ? (
                    <p className="labelErrorValidation">
                      {validation.errors.cpfInput &&
                        `Digite um ${typeMask} válido`}
                    </p>
                  ) : null}
                </div>
              </Col>
              <Col md={4}>
                <div className="mb-3">
                  <Label htmlFor="name" className="form-label">
                    Nome
                  </Label>
                  <Input
                    type="text"
                    className="form-control"
                    id="nameInput"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.nameInput || ''}
                  />
                  {validation.touched.nameInput &&
                  validation.errors.nameInput ? (
                    <p className="labelErrorValidation">
                      {validation.errors.nameInput}
                    </p>
                  ) : null}
                </div>
              </Col>

              <Col md={12}>
                <div className="mb-3">
                  <Label
                    htmlFor="address1ControlTextarea"
                    className="form-label"
                  >
                    Observações
                  </Label>
                  <textarea
                    className="form-control"
                    id="obsInput"
                    rows="3"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.obsInput || ''}
                  ></textarea>
                </div>
              </Col>
              <Col md={12}>
                <div className="mb-3">
                  <h5>Contato</h5>
                </div>
              </Col>

              <Col md={6}>
                <div className="mb-3">
                  <Label htmlFor="contactInput" className="form-label">
                    Nome do Contato
                  </Label>
                  <Input
                    className="form-control"
                    id="contactInput"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.contactInput || ''}
                  />
                  {validation.touched.contactInput &&
                  validation.errors.contactInput ? (
                    <p className="labelErrorValidation">
                      {validation.errors.contactInput}
                    </p>
                  ) : null}
                </div>
              </Col>

              <Col md={6}>
                <div className="mb-3">
                  <Label htmlFor="citynameInput" className="form-label">
                    Email
                  </Label>
                  <Input
                    type="email"
                    className="form-control"
                    id="emailInput"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.emailInput || ''}
                  />
                </div>
              </Col>

              <Col md={4}>
                <div className="mb-3">
                  <Label htmlFor="citynameInput" className="form-label">
                    Celular
                  </Label>
                  <InputPhone
                    id="phone1Input"
                    name="phone1Input"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.phone1Input || ''}
                  />
                  {validation.touched.phone1Input &&
                  validation.errors.phone1Input ? (
                    <p className="labelErrorValidation">
                      {validation.errors.phone1Input}
                    </p>
                  ) : null}
                </div>
              </Col>

              <Col md={4}>
                <div className="mb-3">
                  <Label htmlFor="citynameInput" className="form-label">
                    Telefone
                  </Label>
                  <InputPhone
                    id="phone2Input"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.phone2Input || ''}
                  />
                </div>
              </Col>

              <Col md={4}>
                <div className="mb-3">
                  <Label htmlFor="citynameInput" className="form-label">
                    WhatsApp
                  </Label>
                  <InputPhone
                    id="phone3"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.phone3 || ''}
                  />
                </div>
              </Col>

              <Col md={12}>
                <div className="mb-3">
                  <h5>Endereço</h5>
                </div>
              </Col>
              <Col md={3}>
                <div className="mb-3">
                  <Label htmlFor="ForminputState" className="form-label">
                    CEP
                  </Label>
                  <ZipCodeInput
                    className="form-control"
                    id="zipInput"
                    changeInputs={(e) => {
                      validation.setValues({
                        ...validation.values,
                        zipInput: e.cep,
                        streetInput: e.logradouro,
                        neighborhoodInput: e.bairro,
                        address2Input: e.complemento,
                        cityInput: {
                          label: `${e.localidade} - ${e.uf} `,
                          value: e.ibge,
                        },
                      });
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.zipInput || ''}
                  />
                  {validation.touched.zipInput && validation.errors.zipInput ? (
                    <p className="labelErrorValidation">
                      {validation.errors.zipInput}
                    </p>
                  ) : null}
                </div>
              </Col>

              <Col md={6}>
                <div className="mb-3">
                  <Label htmlFor="ForminputState" className="form-label">
                    Logradouro
                  </Label>
                  <Input
                    className="form-control"
                    id="streetInput"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.streetInput || ''}
                  />
                  {validation.touched.streetInput &&
                  validation.errors.streetInput ? (
                    <p className="labelErrorValidation">
                      {validation.errors.streetInput}
                    </p>
                  ) : null}
                </div>
              </Col>

              <Col md={3}>
                <div className="mb-3">
                  <Label htmlFor="ForminputState" className="form-label">
                    Número
                  </Label>
                  <Input
                    className="form-control"
                    id="numberInput"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.numberInput || ''}
                    maxLength="10"
                  />
                  {validation.touched.numberInput &&
                  validation.errors.numberInput ? (
                    <p className="labelErrorValidation">
                      {validation.errors.numberInput}
                    </p>
                  ) : null}
                </div>
              </Col>

              <Col md={6}>
                <div className="mb-3">
                  <Label htmlFor="ForminputState" className="form-label">
                    Complemento
                  </Label>
                  <Input
                    className="form-control"
                    id="address2Input"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.address2Input || ''}
                  />
                </div>
              </Col>

              <Col md={6}>
                <div className="mb-3">
                  <Label htmlFor="ForminputState" className="form-label">
                    Bairro
                  </Label>
                  <Input
                    className="form-control"
                    id="neighborhoodInput"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.neighborhoodInput || ''}
                  />
                  {validation.touched.neighborhoodInput &&
                  validation.errors.neighborhoodInput ? (
                    <p className="labelErrorValidation">
                      {validation.errors.neighborhoodInput}
                    </p>
                  ) : null}
                </div>
              </Col>

              <Col md={6}>
                <div className="mb-3">
                  <Label htmlFor="cityInput" className="form-label">
                    Cidade
                  </Label>
                  <SelectInputWithSearchApi validation={validation} />
                  {validation.touched.cityInput &&
                  validation.errors.cityInput ? (
                    <p className="labelErrorValidation">
                      {validation.errors.cityInput}
                    </p>
                  ) : null}
                </div>
              </Col>

              <Col lg={12} md={12}>
                <div className="mt-4 mt-md-0">
                  <div>
                    <div className="form-check form-switch form-check-right mb-2">
                      <Input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="isActiveSelect"
                        onChange={() => setIsActive(!isActive)}
                        onBlur={validation.handleBlur}
                        checked={isActive}
                      />
                      <Label
                        className="form-check-label"
                        htmlFor="flexSwitchCheckRightDisabled"
                      >
                        Ativo
                      </Label>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </CardBody>

          <CardFooter>
            <Col md={12}>
              <div className="d-flex align-items-center justify-content-between">
                <span className="card-text">
                  <small className="text-muted">{supplier.last_update}</small>
                </span>
                <div className="text-end">
                  <button
                    type="button"
                    className="btn btn-link"
                    style={{
                      marginRight: '10px',
                    }}
                    onClick={() => {
                      history.goBack();
                    }}
                  >
                    Cancelar
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Salvar
                  </button>
                </div>
              </div>
            </Col>
          </CardFooter>
        </Form>
      </Card>
    </PageWrapper>
  );
};
